import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedDate } from 'react-intl';
import classnames from 'classnames';
import service from 'Api/service';
import { ROOT_URL, saveError } from 'Api';
import * as actions from 'Actions';
import {
  apiToClassNames,
  apiRentalReceiving,
} from 'Constants/displayConstants';
import RentalStatusDisplayer from 'Constants/RentalStatusDisplayer';
import PaginationBoxView from 'Utils/PaginationBoxView';
import Modal from 'Utils/Modal';
import { DeleteCircle } from 'Utils/SvgIcons';
import { capitalizeFirstLetter } from 'HelperFunctions/general';
import originalTerminologies from '../../helper_functions/originalTerminologies';

const plurals = {
  item: 'items',
  accessory: 'accessories',
  purchase: 'addons',
  bundle: 'bundles',
};

class DeleteProduct extends Component {
  state = {
    open: false,
    activeTab: 'rentals',
    rentals: {
      fetching: true,
      items: [],
      pagination: {},
    },
    bundles: {
      fetching: true,
      items: [],
      pagination: {},
    },
  };

  toggleDialog = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleDelete = () => {
    const { type, deleteProduct, closeLoadingSpinner } = this.props;
    deleteProduct(this.props.id, plurals[type]);
  };

  handleReview = () => {
    const { openLoadingSpinner } = this.props;
    openLoadingSpinner('Please wait...');

    this.review('rentals');
    this.review('bundles');
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  review = (tab) => {
    const { type, id } = this.props;
    const productType = plurals[type];

    this.setState({
      [tab]: {
        fetching: true,
        items: [],
        pagination: {},
      },
    });

    const URL = `${ROOT_URL}/inventories/${
      tab === 'rentals'
        ? 'paginated_alerting_items'
        : 'paginated_product_bundles'
    }`;

    service
      .post(URL, {
        inventory_class: apiToClassNames[productType],
        id: id,
        per: 5,
      })
      .then((response) => {
        this.setState(
          {
            [tab]: {
              fetching: false,
              items:
                tab === 'rentals'
                  ? response.data[apiRentalReceiving[productType]]
                  : response.data.bundles,
              pagination: response.data.meta.pagination,
            },
          },
          this.reviewAll
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          const errors = error.response.data;
          const { setErrors } = this.props;

          setErrors(errors);
          this.setState({
            errors: errors,
          });
        }
      });
  };

  reviewAll = () => {
    const { rentals, bundles } = this.state;
    const { closeLoadingSpinner } = this.props;

    if (rentals.fetching || bundles.fetching) {
      return;
    }

    const rentalCount = rentals.items.length;
    const bundleCount = bundles.items.length;

    if (rentalCount > 0 || bundleCount > 0) {
      closeLoadingSpinner();
      this.setState({
        open: true,
        activeTab: rentalCount > 0 ? 'rentals' : 'bundles',
      });
    } else {
      this.handleDelete();
    }
  };

  handlePageChange = (tab, data) => {
    const { selected, navigation } = data;
    const newPage = selected + 1;
    const { first, prev, next, last } = this.state[tab].pagination;
    switch (navigation) {
      case 'manual':
        const link = `/api/inventories/${
          tab === 'rentals'
            ? 'paginated_alerting_items'
            : 'paginated_product_bundles'
        }?page=${newPage}`;
        this.paginate(tab, link);
        break;
      case 'next':
        this.paginate(tab, next);
        break;
      case 'previous':
        this.paginate(tab, prev);
        break;
      case 'first':
        this.paginate(tab, first);
        break;
      case 'last':
        this.paginate(tab, last);
        break;
      default:
        break;
    }
  };

  paginate = (tab, link) => {
    const { type, id } = this.props;
    const productType = plurals[type];

    this.setState({
      [tab]: {
        ...this.state[tab],
        fetching: true,
      },
    });

    service
      .post(import.meta.env.VITE_API_DOMAIN + link, {
        inventory_class: apiToClassNames[productType],
        id: id,
        per: 5,
      })
      .then((response) => {
        this.setState({
          [tab]: {
            fetching: false,
            items:
              tab === 'rentals'
                ? response.data[apiRentalReceiving[productType]]
                : response.data.bundles,
            pagination: response.data.meta.pagination,
          },
        });
      })
      .catch((error) => {
        saveError(error);
      });
  };

  renderItemQty = (item) => {
    const subRentalQty =
      item.subRentals && item.subRentals.length > 0
        ? item.subRentals.reduce(
            (sum, subRental) => (sum += subRental.quantity),
            0
          )
        : 0;

    return subRentalQty > 0
      ? `(${subRentalQty}) ${item.quantity}`
      : item.quantity;
  };

  render() {
    const { name, type } = this.props;
    const { activeTab, open, rentals, bundles } = this.state;
    const { purchaseSingular } = originalTerminologies();
    return (
      <div className='itemDelete'>
        <a
          id='delete_product'
          className='btnLink delete'
          onClick={this.handleReview}
        >
          Delete{' '}
          {type === 'purchase' ? purchaseSingular : capitalizeFirstLetter(type)}
          <DeleteCircle />
        </a>
        <Modal
          open={open}
          toggle={this.toggleDialog}
          className='warn'
          title='Are you sure you want to delete this item?'
          large={true}
          actions={[
            <button
              id='confirm_delete'
              className='btn warn'
              onClick={this.handleDelete}
            >
              Yes, Delete This Item
            </button>,
            <button className='btn cancel' onClick={this.toggleDialog}>
              Cancel
            </button>,
          ]}
        >
          <h2>{name}</h2>
          <div className='tabSelect'>
            {rentals.items.length > 0 && (
              <a
                className={classnames({ active: activeTab === 'rentals' })}
                onClick={() => this.handleTabChange('rentals')}
              >
                Used In Rentals ({rentals.items.length})
              </a>
            )}
            {bundles.items.length > 0 && (
              <a
                className={classnames({ active: activeTab === 'bundles' })}
                onClick={() => this.handleTabChange('bundles')}
              >
                Used In Bundles ({bundles.items.length})
              </a>
            )}
          </div>
          {activeTab === 'rentals' && (
            <section>
              <table className='grid'>
                <thead>
                  <tr>
                    <th>Order Name</th>
                    <th className='medSm'>Order Status</th>
                    <th className='sm center'>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {rentals.items.map((item, index) => (
                    <a key={index} className='rTableRow'>
                      <td
                        className={classnames({
                          alert: item.hasShortage,
                        })}
                      >
                        {item.rentalName}
                      </td>
                      <td>
                        <RentalStatusDisplayer status={item.rentalStatus} />
                      </td>
                      <td
                        className={classnames({
                          center: true,
                          highlight: !item.hasShortage,
                        })}
                      >
                        {this.renderItemQty(item)}
                      </td>
                    </a>
                  ))}
                </tbody>
              </table>
              <PaginationBoxView
                className='pagerWrapper'
                containerClassName='pager'
                pageCount={rentals.pagination.totalPages}
                onPageChange={(data) => this.handlePageChange('rentals', data)}
              />
            </section>
          )}
          {activeTab === 'bundles' && (
            <section>
              <table className='grid'>
                <thead>
                  <tr>
                    <th>Bundle Name</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {bundles.items.map((item, index) => (
                    <a
                      key={index}
                      className='rTableRow'
                      onClick={() => this.handleItemClick(item)}
                    >
                      <td>{item.name}</td>
                      <td>
                        <FormattedDate
                          value={item.createdAt}
                          month='short'
                          year='numeric'
                          day='numeric'
                        />
                      </td>
                    </a>
                  ))}
                </tbody>
              </table>
              <PaginationBoxView
                className='pagerWrapper'
                containerClassName='pager'
                pageCount={bundles.pagination.totalPages}
                onPageChange={(data) => this.handlePageChange('bundles', data)}
              />
            </section>
          )}
        </Modal>
      </div>
    );
  }
}

export default connect(null, actions)(DeleteProduct);
